import { ReactComponent as SearchCriteria } from "./svg/IconSearchCriteria.svg";

export const IconSearchCriteria = () => {
  return <SearchCriteria />;
};
